import { render, staticRenderFns } from "./next-queries.vue?vue&type=template&id=bbf45b62&"
import script from "./next-queries.vue?vue&type=script&lang=ts&"
export * from "./next-queries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports